'use client';

import { ProductsTableModals } from '@/components/products-table/ProductsTableModals';
import type { ProductsTableControllerValue } from '@/components/products-table/use-products-table-controller';
import { GroupTableView } from '@/components/group-tables/GroupTableView';

type ProductsTableViewProps = ProductsTableControllerValue;

export const ProductsTableView = ({ tableBindings, modalsBindings }: ProductsTableViewProps) => (
    <GroupTableView tableBindings={tableBindings} modals={<ProductsTableModals {...modalsBindings} />} />
);
